let snackbar = {
  success: {
    welcome: 'Bem Vindo',
    logout: 'Logout',
    server_connected: 'Servidor Conectado',
    saved: 'Salvo'
  },
  error: {
    server: 'Erro ao contatar Servidor',
    incorrect_login: 'Login ou Senha incorretos',
    logout: 'Erro ao efetuar Logout',
    disconnected: 'Usuário Desconectado',
    save_error: 'Erro ao Salvar Dados',
    query_error: 'Erro ao consultar Dados',
    response_error: 'Erro na resposta do Servidor',
    reconnect_delay: 'Tentando reconectar em ',
    offline_server: 'Servidor Offline',
    disconnected_server: 'Servidor Desconectado',
    action_error: 'Erro ao executar Ação',
    auth_failed: 'Falha na Autenticação',
    invalid_data: 'Resposta de Dados Inválida',
    no_permission: 'Sem Permissão para acessar a página',
    no_page: 'Página não encontrada'
  }
}

export default snackbar
